"use client";import{jsx as e,jsxs as t}from"react/jsx-runtime";import"react";import{twMerge as a}from"tailwind-merge";import{Typography as i}from"../../Base/Typography/Typography.js";import"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{RadioCardContainer as r,StyledRadio as s,RadioCardIcon as d,TitleContainer as o}from"./RadioCard.parts.js";import{useRadioCard as l}from"./useRadioCard.js";const n=n=>{const{disabled:m=!1,isSelected:c=!1,isError:p=!1,onChange:g,isWide:y=!1,className:u,iconName:h,title:x,description:C,testId:f,value:b,name:B}=n,N=null!=h?h:y?null:"receipt",{handleChange:j}=l({checked:c,disabled:m,onChange:g});/*#__PURE__*/
return e("label",{"data-testid":f,role:"radio-card",className:"group",children:/*#__PURE__*/t(r,{"data-testid":"design-system-radioCard--container",isSelected:c,isError:p,isWide:y,disabled:m,className:u,children:[
/*#__PURE__*/e(s,{name:B,value:b,isWide:y,isSelected:c,onChange:j,isError:p,disabled:m}),N&&/*#__PURE__*/e(d,{isError:p,isSelected:c,iconName:N,disabled:m}),
/*#__PURE__*/t(o,{isWide:y,"data-testid":"design-system-radioCard--titleBox",children:[
/*#__PURE__*/e(i,{"data-testid":"design-system-radioCard--title",variant:"body1",className:a("font-medium",y?"text-left":"text-center",m?"text-w-gray-300":"text-w-gray-900"),children:x}),C&&/*#__PURE__*/e(i,{variant:"body2",className:a("font-normal",y?"text-left":"text-center",m?"text-w-gray-300":"text-w-gray-600"),"data-testid":"design-system-radioCard--description",children:C})]})]})})};
/**
 * 라디오 카드 컴포넌트
 *
 * @description
 * 아이콘, 제목, 설명이 포함된 선택 가능한 카드 형태의 라디오 버튼입니다.
 * 가로형(wide) 또는 정사각형 형태로 사용할 수 있으며,
 * 선택, 비활성화, 에러 상태를 표현할 수 있습니다.
 *
 * @param {RadioCardProps} props
 * @param {boolean} [props.disabled=false] - 비활성화 여부
 * @param {boolean} [props.isSelected=false] - 선택 여부
 * @param {boolean} [props.isError=false] - 에러 상태 여부
 * @param {(checked: boolean) => void} props.onChange - 선택 상태 변경 시 호출되는 콜백 함수
 * @param {boolean} [props.isWide=false] - 가로형 카드 여부
 * @param {string} [props.className] - 추가 스타일 클래스
 * @param {string} props.iconName - 표시할 아이콘 이름
 * @param {string} props.title - 카드 제목
 * @param {string} [props.description] - 카드 설명
 * @param {string} [props.testId] - 테스트용 ID
 * @param {string} props.value - 라디오 버튼 값
 * @param {string} props.name - 라디오 버튼 그룹 이름
 *
 * @example
 * // 기본 사용 예시
 * <RadioCard
 *   name="payment"
 *   value="card"
 *   iconName="credit-card"
 *   title="신용카드"
 *   description="신용/체크카드로 결제"
 *   onChange={(checked) => console.log('선택됨:', checked)}
 * />
 *
 * // 가로형 카드 예시
 * <RadioCard
 *   isWide
 *   name="delivery"
 *   value="quick"
 *   iconName="truck"
 *   title="빠른배송"
 *   description="내일 오전까지 배송"
 *   onChange={(checked) => console.log('선택됨:', checked)}
 * />
 */export{n as RadioCard};
